import { createApp, reactive } from 'vue'
import { initAntd } from '@/config/antd'
import App from './App.vue'
import router from './router'
import './permission'
import { initPlugin } from './plugin'
import { initIcon } from './icon'
import { Data, SearchData } from 'complex-data'
import AntdForm from 'complex-component/src/antd/class/AntdForm'
import componetAntConfig from 'complex-component/src/antd/config'
import dataConfig from 'complex-data/config'

dataConfig.DefaultEdit.date.format = 'YYYY/MM/DD'
componetAntConfig.console.EditForm.typeEdit = false

Data.$format = function(data) {
  return reactive(data)
}

SearchData.setForm(AntdForm)

// 设置全局load判断为真
localGlobalData.load = true

const app = createApp(App).use(router)
initIcon(app)
initAntd(app)
initPlugin(app)
app.mount('#app')
